import React from 'react';
import appManager from 'AppManager';
import { Linking } from 'react-native';
import { Device } from 'DeviceUtils';
// eslint-disable-next-line import/no-unresolved
import { PreConsentScene, VoyoUpsell, VoyoPromoScene } from 'Pages/index';
import { EntitlementsResponse, PlayoutsResponse } from '@24i/st-api-connector';
// eslint-disable-next-line import/no-unresolved
import { SUBSCRPTION_TYPE } from 'Pages/PackageInfoScene/getVoyoPackageTexts';

import VoyoConsentDialog from '../../../localGluons/components/VoyoConsentDialog/VoyoConsentDialog';
import RedirectScene from '../RedirectScene';
import { possibleApps } from '../RedirectScene/getVoyoStoreParameters';

export enum EntitlementsActions {
    DeepLink = 'DEEPLINK',
    UpsellMessage = 'UPSELL_MESSAGE'
}

const onAppVoyoContentApproached = async (
    entitlements: EntitlementsResponse,
    itemId: number,
    playouts: PlayoutsResponse,
    setModalContent: (modalContent: unknown) => void
): Promise<JSX.Element | void> => {
    const closeModalCallback = () => {
        setModalContent(null);
    };

    const {
        backstageConnector: { auth, vod }
    } = appManager.getApi();

    let errorMessage = '';

    try {
        const deeplinkToExternalApplication =
            entitlements?.entitled && entitlements?.action === EntitlementsActions.DeepLink;

        const isUpsellSceneExternal =
            !entitlements.entitled && entitlements.action === EntitlementsActions.UpsellMessage;

        // TODO move this functionality to separate function as it is used on different place as well
        if (deeplinkToExternalApplication === true) {
            const { deeplinkUrl, thirdPartyAppId } = await vod.getSmallscreenDeeplink(
                'VOYO',
                itemId
            );
            if (!Device.isWeb && thirdPartyAppId && possibleApps.includes(thirdPartyAppId)) {
                const deeplinkMobileUrl = deeplinkUrl.replace('https', thirdPartyAppId);
                Linking.openURL(deeplinkMobileUrl).catch(() =>
                    setModalContent(
                        <RedirectScene
                            close={closeModalCallback}
                            thirdPartyApp={thirdPartyAppId}
                            deeplinkUrl={deeplinkUrl}
                        />
                    )
                );
            } else {
                Linking.openURL(deeplinkUrl);
            }
        }
        if (isUpsellSceneExternal === true) {
            setModalContent(<VoyoUpsell close={closeModalCallback} />);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
        errorMessage = e.errorCode;
        if (errorMessage === 'NO_CONSENT') {
            try {
                const getConsentsDefinition = await auth.getConsentsDefinition('VOYO');
                const voyoConsentDialog = (
                    <VoyoConsentDialog
                        backgroundImageUrl={
                            Device.isTabletOrWeb
                                ? getConsentsDefinition.backgroundImageUrlLandscape
                                : getConsentsDefinition.backgroundImageUrlPortrait
                        }
                        isLandscape={!!Device.isTabletOrWeb}
                        close={closeModalCallback}
                        titleDescription={getConsentsDefinition.titleDescription}
                        bottomDescription={getConsentsDefinition.bottomDescription}
                        continueButtonText={getConsentsDefinition.continueButtonText}
                        title={getConsentsDefinition.title}
                        logoUrl={getConsentsDefinition.logoUrl}
                        consentDefinitions={getConsentsDefinition.consentDefinitions}
                        itemId={itemId}
                        setModalContent={setModalContent}
                    />
                );
                const voyoPreConsentDialog = (): void =>
                    setModalContent(
                        <PreConsentScene
                            close={closeModalCallback}
                            onContinue={() => setModalContent(voyoConsentDialog)}
                        />
                    );

                setModalContent(
                    <VoyoPromoScene
                        onContinue={
                            playouts.type === SUBSCRPTION_TYPE.TRIAL
                                ? () => voyoPreConsentDialog()
                                : () => setModalContent(voyoConsentDialog)
                        }
                        consentsDefinition={getConsentsDefinition}
                    />
                );
            } catch {
                console.log(Error);
            }
        }
    }
};

export default onAppVoyoContentApproached;
